// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1373":"4e9627df","2268":"574d625b","2396":"2a80e288","3235":"d5ba1be9","5309":"ee45082d","5787":"98e34868","6714":"21fddfd0","6971":"ad3d6839","7817":"05719ea8","8624":"6e527269"}[chunkId] + ".chunk.css";
};